export default function (initialDataInteractor, newQuestionnaireData) {
  initialDataInteractor.data.questionnaires.push(newQuestionnaireData.questionnaire);
}